window.addEventListener('load', (event) => {
  load()
});

const load = () => {
  const quantities = document.querySelectorAll('.product-quantity')
  quantities.forEach((quantity) => {
    quantity.addEventListener('change', updateCart)
  });
}

function updateCart() {
  const productId = this.getAttribute('data-product-id')
  const itemId = this.getAttribute('data-item-id')
  const productGroup = this.getAttribute('data-product-group')
  const quantity = this.value

  this.form.addEventListener('formdata', (e) => {
    const fd = e.formData

    // データをセット
    fd.set('product_id', productId)
    fd.set('item_id', itemId)
    fd.set('quantity', quantity)
    fd.set('product_group', productGroup)
  })

  this.form.submit()
}
